
import { Button, InputAdornment, TextField, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Box} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DelimiterDialog from "./DelimiterDialog";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import LightTooltip from "../../commonComponents/LightTooltip";

function DelimiterInput(props) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const [modalOpen, setModalOpen] = useState(false);
  const [delimInput, setDelimInput] = useState('');
  const [editTooltipOpen, setEditTooltipOpen] = useState(false);
  const [value, setValue] = useState('')
  const dispatch = useDispatch();
  let classes = props.className || '';

  if (props.default) classes += ' default-delimiter-field';

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({screen: parentScreen, key, value}));
  }

  const delimDisplay = (val, modal) => {
    
    // Display values in certain ways depending on a few specific conditions:
    // - If no delim val -> 'No Delimiter Chosen'.
    // - Replace 'CR' and 'LF' (ascii 13 and 10) OR '%0D' '%0A' -> display 'CR', 'LF', 'CRLF' in latin characters.
    // - If val is one or two char length -> display 'ASCII 42 (*)' delimited by comma.
    // - else -> display the decoded string (even if it's just empty chars ?)
    if(val === undefined) return '';
    if (!modal) {
      if (typeof val === 'boolean'|| val === t('TXT_NO_DELIM_CHOSEN') || !val) return t('TXT_NO_DELIM_CHOSEN');
    }
    if (val === "CR" || val === "%0D" || val === "\r") return "CR";
    if (val === "LF" || val === "%0A" || val === "\n" ) return "LF";
    if (val === "CRLF" || val === "%0D%0A") return "CRLF";
    const crlfIndex = val.indexOf('%0D%0A');
    if (crlfIndex !== -1) {
      // Handle the case where val includes %0D%0A(CRLF)
      const beforeCRLF = decodeURIComponent(val.substring(0, crlfIndex));
      const afterCRLF = decodeURIComponent(val.substring(crlfIndex + 6));
      return beforeCRLF + 'CRLF' + afterCRLF;
    }
    try { val = decodeURIComponent(val) } 
    catch (e) { 
      //case - malformed URI
      //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
    }
    return val.length < 3 ?
      val.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join(', ')
      : val;
  }

  const handleEditAction = (action) => {
    switch (action) {
      case 'click':
        setDelimInput(delimDisplay(rightTree.tree.templateHeader[props.name], true))
        setModalOpen(true);
        setEditTooltipOpen(false);
        break;
      case 'enter':
        setEditTooltipOpen(true)
        break;
      case 'leave':
        setEditTooltipOpen(false);
        break;
    }
  }

  const handleModalAction = (save) => {
    if (save) handleChange(props.name, delimInput);
    setModalOpen(false);
  }

  const handleDelimitedInput = (val) => {
    if (val) {
      const newDelimVal = delimDisplay(val, true)
      setValue(delimDisplay(newDelimVal, true))
    } else setValue(val, true)
  }

  useEffect(() => {
    const templateHeader = delimDisplay(rightTree.tree.templateHeader[props.name], true);
    setValue(templateHeader);
  }, [rightTree.tree.templateHeader[props.name]]);

  return (
    <>
      <div className="flex width-100">
        {/* Text Field that's shown in template properties */}
        <TextField
          size='small'
          variant='outlined'
          className='width-100 delim-button'
          label={props.label}
          value={value || t("TXT_NO_DELIM_CHOSEN")}
          onClick={() => handleEditAction('click')}
          onMouseEnter={() => handleEditAction('enter')}
          onMouseLeave={() => handleEditAction('leave')}
          InputProps={{
            readOnly: true,
            style: {paddingRight: "2px"},
            endAdornment: (
            <InputAdornment position="end">
              <LightTooltip 
                className="margin-left-4" 
                title={t('CASCHE_EDIT')}
                placement={"right-start"}
                open={editTooltipOpen}
              >
                <Button 
                  size='small'
                  sx={{
                    width: '100% !important', 
                    minWidth: '100% !important',
                    
                  }}
                  onClick={() => handleEditAction('click')}
                  onMouseEnter={() => handleEditAction('enter')}
                  onMouseLeave={() => handleEditAction('leave')}
                >
                  <BorderColorIcon fontSize='small'/>
                </Button>
              </LightTooltip>
            </InputAdornment>)
          }}
        />
        <DelimiterDialog 
          modalOpen={modalOpen} 
          close={() => handleModalAction()} 
          handleInput={handleDelimitedInput}
          val={value}
          name={props.name}
          >
        </DelimiterDialog>
      </div>
    </>
  )
}

export default DelimiterInput
